import { render, staticRenderFns } from "./KycOtpActivity.vue?vue&type=template&id=81f8b8d6&scoped=true&"
import script from "./KycOtpActivity.vue?vue&type=script&lang=js&"
export * from "./KycOtpActivity.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=81f8b8d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f8b8d6",
  null
  
)

export default component.exports